import { render } from "./reportTkReceInfo.vue?vue&type=template&id=4c30c4a5"
import script from "./reportTkReceInfo.vue?vue&type=script&lang=js"
export * from "./reportTkReceInfo.vue?vue&type=script&lang=js"

import "./reportTkReceInfo.vue?vue&type=style&index=0&id=4c30c4a5&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__